import { SVGAttributes } from "react";

const BuildSvg = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      viewBox="0 0 36 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.00024 8L27.0002 26"
        stroke="#CFB2FF"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 13L10 26"
        stroke="#FFA686"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.00006 4.99994L17 4.99999L7.00005 15.0001L3.00012 11L9.00006 4.99994Z"
        fill="#CFB2FF"
        stroke="#CFB2FF"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.8449 9.88343L28.8707 13.8576L23.4419 12.4029L21.9873 6.97415L25.9614 3"
        stroke="#FFA686"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BuildSvg;
